<div class="doctor" [class.active]="isActive">
    <!-- Desktop version -->
    <ng-container *ngIf="!isMobile">
        <div class="doctor__img">
            <img
                src="{{ getImgSrcDoc(doctor.doctorId) }}"
                (error)="getDocImgDefault($event)"
                alt="doctor photo"
            />
        </div>
        <div class="doctor-container">
            <div class="doctor-container__about-doctor">
                <div class="doctor-container__name">
                    {{ getFioDoc(doctor) }}
                    <button
                        type="button"
                        class="doctor-container__info"
                        (click)="openDocInfoModal(doctor, $event)"
                        title="Нажмите для получения информации о враче"
                        *ngIf="doctor.infoDoc && doctor.infoDoc.length > 0"
                    >
                        <img src="./assets/icons/actions/information.svg" alt="info" />
                    </button>
                </div>
                <div
                    class="doctor-container__description"
                    *ngIf="doctor.infoDoc && doctor.infoDoc.length > 0"
                >
                    <div
                        class="doctor-container__description-text"
                        [title]="
                            experienceText(doctor.workExp) +
                            ' ' +
                            doctor.workSpec
                        "
                    >
                        {{ experienceText(doctor.workExp) }}
                        <span class="doctor-container__description-dot"> </span>
                        {{ doctor.workSpec }}
                    </div>
                </div>
            </div>
            <div class="doctor-container__about-record">
                <div
                    class="doctor-container__service-select"
                    [attr.data-doctor-id]="doctor.doctorId"
                >
                    <input
                        type="text"
                        class="doctor-container__service-select-trigger"
                        [placeholder]="
                            doctor.srvList?.length === 0
                                ? 'Список пуст'
                                : selectedSrvMap[doctor.doctorId]
                                  ? selectedSrvMap[doctor.doctorId].text
                                  : 'Выберите услугу'
                        "
                        (focus)="toggleSelect(doctor.doctorId)"
                        #InputBlocServ
                        [(ngModel)]="searchStrSrv[doctor.doctorId]"
                        (ngModelChange)="
                            changeSearchSrv($event, doctor.doctorId)
                        "
                        [ngClass]="{
                            selected: !!selectedSrvMap[doctor.doctorId],
                        }"
                    />
                    <img
                        src="./assets/icons/navigation/expand-details.svg"
                        alt="dropdown_arrow"
                        width="16px"
                        height="16px"
                        class="doctor-container__service-select-trigger_arrow"
                        [ngClass]="
                            openSelectStates[doctor.doctorId]
                                ? 'rotateArrow'
                                : ''
                        "
                        (click)="InputBlocServ.focus()"
                    />

                    <div
                        class="dropdown-list"
                        *ngIf="
                            openSelectStates[doctor.doctorId] &&
                            doctor.srvList?.length !== 0
                        "
                    >
                        <div
                            *ngFor="let docSrv of doctor.srvList"
                            class="dropdown-list__option"
                            (click)="selectService(docSrv, doctor)"
                        >
                            <div class="dropdown-list__option-text">
                                <span>{{ docSrv.text }}</span>
                                <div class="dropdown-list__option-info">
                                    <button
                                        *ngIf="docSrv.description"
                                        (click)="
                                            openServDescModal(docSrv, $event)
                                        "
                                    >
                                        <img src="./assets/icons/actions/information.svg" />
                                    </button>
                                </div>
                            </div>

                            <div class="dropdown-list__option-price">
                                <span *ngIf="docSrv.price != 0"
                                    >{{
                                        docSrv.price | priceSpace : "1.2-2"
                                    }}
                                    руб.</span
                                >
                                <div class="dropdown-list__option-price-icon">
                                    <img
                                        *ngIf="docSrv.isCreatePayOrder == 1"
                                        src="./assets/icons/payments/ruble.svg"
                                    />
                                </div>
                                <!-- <span *ngIf="docSrv.price == 0">Бесплатно</span> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="doctor-container__rnumb-count">
                    {{ rcountText(doctor.rCount) }}
                </div>
            </div>
        </div>
    </ng-container>

    <!-- Mobile version -->
    <ng-container *ngIf="isMobile">
        <div class="doctor-card">
            <div class="doctor-card__top">
                <img
                    class="doctor-card__img"
                    src="{{ getImgSrcDoc(doctor.doctorId) }}"
                    (error)="getDocImgDefault($event)"
                    alt="doctor photo"
                />
                <div class="doctor-card__description">
                    <div class="doctor-card__description-name">
                        {{ getFioDoc(doctor) }}
                    </div>
                    <div class="doctor-card__description-rnumb-count">
                        {{ rcountText(doctor.rCount) }}
                    </div>
                </div>
            </div>
            <button
                class="doctor-card__sevice"
                [disabled]="!doctor.srvList || doctor.srvList.length === 0"
                (click)="pickDoctorHandler(doctor)"
            >
                {{
                    doctor.srvList && doctor.srvList.length > 0
                        ? 'Выберите услугу'
                        : 'Нет доступных услуг'
                }}
            </button>
        </div>
    </ng-container>
</div>
